import React, { Children, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  aspectRatio: number;
  children: React.ReactNode;
}

const ImageSlider: React.FC<Props> = (props) => {
  const imageSlideRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [currentDeltaX, setCurrentDeltaX] = useState<number>(0);
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      currentSlide !== slides.length - 1 && setCurrentSlide(currentSlide + 1);
      setCurrentDeltaX(0);
    },
    onSwipedRight: () => {
      currentSlide !== 0 && setCurrentSlide(currentSlide -1 );
      setCurrentDeltaX(0);
    },
    onSwiping: (eventData) => setCurrentDeltaX(eventData.deltaX),
    preventScrollOnSwipe: true
  });

  const slides = Children.toArray(props.children);

  return (
    <div
      ref={imageSlideRef}
      style={{
        backgroundColor: colors.grayLightest,
        overflow: 'hidden',
        paddingTop: `${(1/props.aspectRatio) * 100}%`,
        position: 'relative',
        width: '100%'
      }}
    >
      <div {...swipeHandlers}>
        {
          slides.map((child, idx) => {
            let left;
            if (idx === currentSlide) {
              left = 0 + currentDeltaX;
            } else {
              left = (idx - currentSlide) * (imageSlideRef?.current?.offsetWidth || 0) + currentDeltaX;
            }

            return (
              <div
                key={idx}
                style={{
                  height: 'auto',
                  left,
                  position: 'absolute',
                  top: 0,
                  transition: 'left 0.15s ease-out, visibility 0.15s ease-out',
                  visibility: idx === currentSlide ? 'visible' : 'hidden',
                  width: '100%'
                }}
              >
                {child}
              </div>
            );
          })
        }
      </div>

      {
        !!slides.length && (
          <div
            className="d-flex justify-content-center u-padding-V-s"
            style={{
              background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))',
              bottom: 0,
              gap: 10,
              left: 0,
              position: 'absolute',
              width: '100%'
            }}
          >
            {
              slides.map((child, idx) => (
                <div
                  key={idx}
                  className="u-padding-V-s"
                  onClick={() => setCurrentSlide(idx)}
                  style={{ cursor: 'pointer' }}
                >
                  <div
                    style={{
                      backgroundColor: currentSlide === idx ? '#fff' : colors.grayLighter,
                      height: 3,
                      width: 32
                    }}
                  />
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  );
};

export default ImageSlider;
